import React from 'react'
import './sidebaroption.css'
function SidebarOption({flex=true,title,Icon,active}) {

    return (
        <div  style={{flexDirection:`${flex?"row":"column"}`}} className={`sidebarOption ${active&&'active'}`}>
            <Icon/>
            <span>{title}</span>
            
        </div>
    )
}

export default SidebarOption
